import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { accessControlApi, type UserDto } from '../api/access-control.client'

export const USERS_LOOKUP_QUERY_KEY = [
  'access-control',
  'users-lookup',
] as const

const keyByCognitoUserId = (users: UserDto[]) =>
  new Map(users.map((user) => [user.cognitoUserId, user]))

/**
 * Many users' RBAC roles in one request, keyed by cognito user id, for pages
 * that list people outside Permission Management. Skipped until there are ids
 * and the caller says the viewer may read them, so a viewer without Read on
 * UserPermission never sees a 403. Ids with no person row are absent from the
 * map. The key changes with the id list, so the previous rows stand in while
 * a changed list is fetched rather than every row losing its roles meanwhile.
 */
export function useUsersLookupQuery(cognitoUserIds: string[], enabled = true) {
  return useQuery({
    queryKey: [...USERS_LOOKUP_QUERY_KEY, cognitoUserIds],
    queryFn: () => accessControlApi.lookupUsers(cognitoUserIds),
    select: keyByCognitoUserId,
    placeholderData: keepPreviousData,
    enabled: enabled && cognitoUserIds.length > 0,
    retry: false,
    refetchOnWindowFocus: false,
  })
}
